import React, {useEffect, useState} from 'react';
import { Link, useNavigate } from 'react-router-dom';

async function getUserSubscription() {
    const response = await fetch('/api/get-account-subscription', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        const subscription = await response.json();
        return subscription;
    } else {
        return false;
    }
}

async function getUserData() {
    const response = await fetch('/api/get-account-data', {
        method: 'POST',
        headers: {
            "Content-Type": "application/json"
        },
        credentials: "include",
    });

    if (response.ok) {
        const user_data = await response.json();
        return user_data;
    } else {
        return false;
    }
}

const logout = async (navigate) => {
    const response = await fetch("/api/logout", {
        method: "POST",
        credentials: "include"
    });

    if (response.ok) {
        navigate('/');
    }
}

function RightHeader({userNotifications, currentPage}) {
    const navigate = useNavigate();

    const [isVisible, setIsVisible] = useState(false);
    const [userSubscription, setUserSubscription] = useState("free")
    const [userName, setUserName] = useState("")

    useEffect(() => {
        async function fetchData() {
            setUserSubscription(await getUserSubscription());
            const userData = await getUserData()
            setUserName(userData.name + " " + userData.surname)
        }

        fetchData()
    }, [])

    const toggleVisibility = () => {
        setIsVisible(!isVisible);
    };

    const handleLogout = () => {
        logout(navigate);
    };

    return (
        <header className="flex items-center justify-between border-b border-solid border-white/10 bg-background-light dark:bg-background-dark px-4 md:px-10 py-3 sticky top-0 z-50">
            <Link to="/">
                <div className="flex items-center gap-3">
                    <div className="size-8 bg-primary rounded flex items-center justify-center">
                        <span className="material-symbols-outlined text-white text-xl">speed</span>
                    </div>
                    <h1 className="text-xl font-bold tracking-tight text-white uppercase italic"><span className="text-primary">Live</span>Telemetry</h1>
                </div>
            </Link>
            <div className="flex-1 justify-end gap-8 items-center hidden md:flex">
                <nav className="flex items-center gap-9">
                    <Link to="/dashboard"><p className="text-[#92adc9] hover:text-white text-sm font-medium transition-colors">Dashboard</p></Link>
                    <Link to="/sessions"><p className={`${currentPage === "Sessions" ? "text-white border-b-2 border-primary pb-1" : "text-[#92adc9] hover:text-white"} text-sm font-medium transition-colors`}>Sessions</p></Link>
                    <Link to="/account-settings"><p className={`${currentPage === "Settings" ? "text-white border-b-2 border-primary pb-1" : "text-[#92adc9] hover:text-white"} text-sm font-medium transition-colors`}>Settings</p></Link>
                </nav>
                <div className="flex gap-2">
                    <Link to="/friends">
                        <button className="relative flex items-center justify-center rounded-lg h-10 w-10 bg-[#233648] text-white hover:bg-primary/20 transition-all">
                            <span className="material-symbols-outlined text-[20px]">notifications</span>
                            {userNotifications === true && (
                                <span className="absolute top-2.5 right-2.5 flex h-2 w-2">
                                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-racing-red opacity-75"></span>
                                    <span className="relative inline-flex rounded-full h-2 w-2 bg-acc-red"></span>
                                </span>
                            )}
                        </button>
                    </Link>
                </div>
            </div>

            <div className="relative group md:hidden">
                <div className="size-10 rounded-full bg-[#233648] border border-[#324d67] flex items-center justify-center cursor-pointer" onClick={toggleVisibility}>
                    <span className="material-symbols-outlined">person</span>
                </div>

                <div className={`absolute top-full right-0 mt-3 w-64 bg-[#111a22] border border-[#324d67] rounded-lg shadow-2xl dropdown-glow z-[60] overflow-hidden ${isVisible ? 'visible' : 'invisible'}`}>
                    <div className="p-4 bg-gradient-to-b from-[#1a2b3c] to-transparent border-b border-[#324d67]/50">
                        <div className="flex items-center gap-3">
                            <div className="size-10 rounded bg-primary/20 border border-primary/30 flex items-center justify-center">
                                <span className="material-symbols-outlined text-primary">person</span>
                            </div>
                            <div className="flex flex-col">
                                <span className="text-sm font-bold text-white tracking-tight uppercase">{userName}</span>
                                <span className="text-[10px] font-bold text-acc-cyan uppercase tracking-widest">{userSubscription}</span>
                            </div>
                        </div>
                    </div>
                    <div className="p-1.5">
                        <Link to="/dashboard">
                            <p className="flex items-center gap-3 px-3 py-2.5 rounded text-[#92adc9] hover:text-white hover:bg-primary/10 transition-colors group/item max-h-[40px]">
                                <span className="material-symbols-outlined text-lg group-hover/item:text-primary">dashboard</span>
                                <span className="text-xs font-bold uppercase tracking-wide">Dashboard</span>
                            </p>
                        </Link>

                        <Link to="/account-settings">
                            <p className="flex items-center gap-3 px-3 py-2.5 rounded text-[#92adc9] hover:text-white hover:bg-primary/10 transition-colors group/item max-h-[40px]">
                                <span className="material-symbols-outlined text-lg group-hover/item:text-primary">settings</span>
                                <span className="text-xs font-bold uppercase tracking-wide">Account Settings</span>
                            </p>
                        </Link>
    
                        {userSubscription === "free" &&
                            <Link to="/subscription-plans">
                                <p className="flex items-center gap-3 px-3 py-2.5 rounded text-[#92adc9] hover:text-white hover:bg-primary/10 transition-colors group/item max-h-[40px]">
                                    <span className="material-symbols-outlined text-lg group-hover/item:text-primary">workspace_premium</span>
                                    <span className="text-xs font-bold uppercase tracking-wide">Subscription Plan</span>
                                </p>
                            </Link>
                        }

                        <Link to="/friends">
                            <p className="flex relative items-center gap-3 px-3 py-2.5 rounded text-[#92adc9] hover:text-white hover:bg-primary/10 transition-colors group/item max-h-[40px]">
                                <span className="material-symbols-outlined text-lg group-hover/item:text-primary">person</span>
                                <span className="text-xs font-bold uppercase tracking-wide">Friends</span>

                                {userNotifications && (
                                    <span className="absolute top-2.5 left-[23px] flex h-2 w-2">
                                        <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-racing-red opacity-75"></span>
                                        <span className="relative inline-flex rounded-full h-2 w-2 bg-acc-red"></span>
                                    </span>
                                )}
                            </p>
                        </Link>

                        <Link to="/sessions">
                            <p className="flex items-center gap-3 px-3 py-2.5 rounded text-[#92adc9] hover:text-white hover:bg-primary/10 transition-colors group/item max-h-[40px]">
                                <span className="material-symbols-outlined text-lg group-hover/item:text-primary">database</span>
                                <span className="text-xs font-bold uppercase tracking-wide">Sessions</span>
                            </p>
                        </Link>
    
                        <div className="h-px bg-[#233648] mt-[10px] mb-[10px]"></div>
    
                        <p onClick={handleLogout} className="flex items-center gap-3 px-3 py-2.5 rounded text-acc-red hover:bg-acc-red/10 transition-colors group/item max-h-[40px] cursor-pointer">
                            <span className="material-symbols-outlined text-lg">logout</span>
                            <span className="text-xs font-bold uppercase tracking-wide">Logout</span>
                        </p>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default RightHeader;